export const ClarityEvent = {
    SIGN_IN: "sign-in",
    SIGN_UP: "sign-up",
    UPGRADE_CLICK: "upgrade-click",
    UPGRADE_CANCEL: "upgrade-cancel",
    CHECKOUT_CLICK: "checkout-click",
    START_ONBOARDING: "start-onboarding",
} as const;

export type ClarityEvent = (typeof ClarityEvent)[keyof typeof ClarityEvent];
